/* @generated from adl module ferovinum.sourcecontracts.productpackaging */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.product_packaging` contract.
 */
export interface ProductPackagingSource {
  id: ferovinum_app_db.ProductPackagingId;
  productId: ferovinum_app_db.ProductId;
  /**
   * Units inside one package; always 1 for singles.
   */
  numberOfItems: (number|null);
  packagingType: common_strings.StringNE;
  gtin: (common_strings.StringNE|null);
  gtinEffectiveDate: (common.LocalDate|null);
  /**
   * Centimetres.
   */
  height: (number|null);
  /**
   * Centimetres.
   */
  width: (number|null);
  /**
   * Centimetres.
   */
  depth: (number|null);
  /**
   * Kilograms.
   */
  weight: (number|null);
  casesPerTier: (number|null);
  tiersPerPallet: (number|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeProductPackagingSource(
  input: {
    id: ferovinum_app_db.ProductPackagingId,
    productId: ferovinum_app_db.ProductId,
    numberOfItems: (number|null),
    packagingType: common_strings.StringNE,
    gtin: (common_strings.StringNE|null),
    gtinEffectiveDate: (common.LocalDate|null),
    height: (number|null),
    width: (number|null),
    depth: (number|null),
    weight: (number|null),
    casesPerTier: (number|null),
    tiersPerPallet: (number|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ProductPackagingSource {
  return {
    id: input.id,
    productId: input.productId,
    numberOfItems: input.numberOfItems,
    packagingType: input.packagingType,
    gtin: input.gtin,
    gtinEffectiveDate: input.gtinEffectiveDate,
    height: input.height,
    width: input.width,
    depth: input.depth,
    weight: input.weight,
    casesPerTier: input.casesPerTier,
    tiersPerPallet: input.tiersPerPallet,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ProductPackagingSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.productpackaging","decl":{"annotations":[{"value":{"modelName":"source__app_db.product_packaging","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.product_packaging` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductPackagingId"}},"parameters":[]}},{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[{"value":"Units inside one package; always 1 for singles.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"numberOfItems","default":{"kind":"nothing"},"name":"numberOfItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"packagingType","default":{"kind":"nothing"},"name":"packagingType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"gtin","default":{"kind":"nothing"},"name":"gtin","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"gtinEffectiveDate","default":{"kind":"nothing"},"name":"gtinEffectiveDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"value":"Centimetres.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"value":"Centimetres.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"value":"Centimetres.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"depth","default":{"kind":"nothing"},"name":"depth","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"value":"Kilograms.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"weight","default":{"kind":"nothing"},"name":"weight","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[],"serializedName":"casesPerTier","default":{"kind":"nothing"},"name":"casesPerTier","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"tiersPerPallet","default":{"kind":"nothing"},"name":"tiersPerPallet","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ProductPackagingSource","version":{"kind":"nothing"}}};

export const snProductPackagingSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.productpackaging", name:"ProductPackagingSource"};

export function texprProductPackagingSource(): ADL.ATypeExpr<ProductPackagingSource> {
  return {value : {typeRef : {kind: "reference", value : snProductPackagingSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.productpackaging.ProductPackagingSource" : ProductPackagingSource_AST
};
